import React from "react";
import { sparketGold } from "utils/constants.ts";

interface SimpleWithdrawalButtonProps {
  onWithdraw: () => void;
  disabled: boolean;
  processing: boolean;
}

const SimpleWithdrawalButton: React.FC<SimpleWithdrawalButtonProps> = ({
  onWithdraw,
  disabled,
  processing,
}) => {
  return (
    <div style={{ marginTop: "20px" }}>
      {/* Withdraw Button */}
      <button
        onClick={onWithdraw}
        disabled={disabled || processing}
        style={{
          width: "100%",
          padding: "12px",
          backgroundColor: disabled || processing ? "#444" : sparketGold,
          color: disabled || processing ? "#888" : "black",
          border: "none",
          borderRadius: "6px",
          fontSize: "15px",
          fontWeight: "600",
          cursor: disabled || processing ? "not-allowed" : "pointer",
          transition: "all 0.15s ease",
        }}
      >
        {processing ? "Processing..." : "Withdraw"}
      </button>
    </div>
  );
};

export default SimpleWithdrawalButton;